<template>
  <div class="container">
    <section class="cyan-background">
      <div class="center-div">
        <div class="navi-title">
          <h1>プラン・料金</h1>
        </div>
      </div>
      <div class="center-div" style="padding-bottom: 25px">
        <div class="flex-navi-container">
          <div class="navi-box">
            <a href="#long-term"> 長期利用 </a>
          </div>
          <div class="navi-box">
            <a href="#short-term"> 短期利用 </a>
          </div>
          <div class="navi-box">
            <a href="#option"> オプション </a>
          </div>
          <div class="navi-box">
            <a href="#price-system"> 料金体系 </a>
          </div>
        </div>
      </div>
    </section>
    <section id="long-term" class="long-term margin-top-60">
      <div class="header-container">
        <div class="empty-div">&nbsp;</div>
        <div class="header-content">長期利用の料金プラン</div>
      </div>
      <div class="center-div">
        <p>
          WeRUNの料金は、ご利用用途に合わせてお得な長期プランを用意しています。
        </p>
        <table class="pricing-table-box">
          <tbody>
            <tr>
              <td width="20%" class="pricing-table-box-text"></td>
              <td width="20%">
                <div class="pricing-table-box-item">
                  <div class="pricing-table-box-item-price">
                    <p class="package-desc">小人数</p>
                    <p class="package-name">Free</p>
                    <p class="package-price">無料<span>&nbsp;</span></p>
                    <p class="package-desc">最低利用人数：5人</p>
                  </div>
                </div>
              </td>
              <td width="20%">
                <div class="pricing-table-box-item">
                  <div class="pricing-table-box-item-price">
                    <p class="package-desc">スモールスタート</p>
                    <p class="package-name">Small</p>
                    <p class="package-price">150円<span>/月/ID</span></p>
                    <p class="package-desc">最低契約ID数：10</p>
                  </div>
                </div>
              </td>
              <td width="20%">
                <div class="pricing-table-box-item">
                  <div class="pricing-table-box-item-price">
                    <p class="package-desc">企業/団体に最適</p>
                    <p class="package-name">Pro</p>
                    <p class="package-price">300円<span>/月/ID</span></p>
                    <p class="package-desc">最低契約ID数：10</p>
                  </div>
                </div>
              </td>
              <td width="20%">
                <div class="pricing-table-box-item">
                  <div class="pricing-table-box-item-price">
                    <p class="package-desc">福利厚生の充実</p>
                    <p class="package-name">VIP</p>
                    <p class="package-price">600円<span>/月/ID</span></p>
                    <p class="package-desc">最低契約ID数：10</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Free Domain</td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Websites</td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Bandwidth</td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>MySQL Databases</td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Disk Space</td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Email Addresses</td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Premium DNS</td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>SSL Certificate</td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
            <tr class="pricing-table-box-list">
              <td>Support</td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon"></span>
              </td>
              <td>
                <span class="glyphicon">〇</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section id="short-term" class="short-term margin-top-60">
      <div class="header-container">
        <div class="empty-div">&nbsp;</div>
        <div class="header-content">WeRunの短期料金プラン</div>
      </div>
      <div class="center-div">
        <p>
          Carelyの料金は、システムとサービスの組み合わせで３つのプランを用意しています。
        </p>
      </div>
      <div class="center-div">
        <div>
          <table class="pricing-table-box" id="infoBox">
            <colgroup>
              <col span="1" style="background-color: rgb(195, 217, 226)" />
              <col span="2" style="background-color: white" />
            </colgroup>
            <tbody>
              <tr>
                <td width="30%">
                  <div class="pricing-table-box-item">
                    <div class="pricing-table-box-item-price">
                      <p class="package-name">登録ID数</p>
                    </div>
                  </div>
                </td>
                <td width="35%">
                  <div class="pricing-table-box-item">
                    <div class="pricing-table-box-item-price">
                      <p class="package-name">Smallプラン</p>
                    </div>
                  </div>
                </td>
                <td width="35%">
                  <div class="pricing-table-box-item">
                    <div class="pricing-table-box-item-price">
                      <p class="package-name">Basicプラン</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>1~100</td>
                <td>
                  <span>¥40,000</span>
                </td>
                <td>
                  <span>¥60,000</span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>101~200</td>
                <td>
                  <span>¥80,000</span>
                </td>
                <td>
                  <span>¥120,000</span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>Bandwidth</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>1~100</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>Disk Space</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>Email Addresses</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span class="glyphicon"></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>Premium DNS</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>SSL Certificate</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
              <tr class="pricing-table-box-list">
                <td>Support</td>
                <td>
                  <span></span>
                </td>
                <td>
                  <span></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="option" class="center-div" style="width: 95">
          <div class="grey-background option-div">オプション</div>
          <div class="center-div" style="width: 100%">
            <div class="option-wrapper">
              <div class="option-row">
                <div class="option-column" style="flex: 3">
                  <div class="option-first-column">オプション1</div>
                  <div class="option-first-column">オプション2</div>
                  <div class="option-first-column">オプション3</div>
                  <div class="option-first-column">オプション4</div>
                  <div class="option-first-column">オプション5</div>
                </div>
                <div class="option-column" style="flex: 7">
                  <div class="option-second-column">
                    オリジナルバーチャルルート
                  </div>
                  <div class="option-second-column">データ集計</div>
                  <div class="option-second-column">広告掲載</div>
                  <div class="option-second-column">
                    オンラインイベント企画と運営
                  </div>
                  <div class="option-second-column">
                    教育/非営利団体/公益法人向けプラン
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="price-system"
      class="cyan-background margin-top-60"
      style="padding-bottom: 75px"
    >
      <div>
        <div class="header-container padding-top-50">
          <div class="empty-div">&nbsp;</div>
          <div class="header-content">料金体系</div>
        </div>
      </div>
      <div class="center-div">
        <p>
          ご利用料金は、各プランの月額料金と各サービスの初期費用、ならびに各種オプション料金の合算となります。
        </p>
      </div>
      <div class="center-div" style="width: 100%">
        <div class="flex-container">
          <div class="formula-box">
            <div class="formula-box-head">プランの月額料金</div>
            <div class="formula-box-body">※課金対象：従業員数</div>
          </div>
          +
          <div class="formula-box">
            <div class="formula-box-head">初期費用</div>
            <div class="formula-box-body">
              クラウド：月額費用3ヶ月分 <br />
              その他：1000円 x 従業員数
            </div>
          </div>
          +
          <div class="formula-box">
            <div class="formula-box-head">オプション料金</div>
            <div class="formula-box-body">
              セキュリティパック <br />CarelyPlace <br />産業医・保健師紹介など
            </div>
          </div>
          =
          <div class="formula-box">
            <div class="formula-box-end">プランの月額料金</div>
          </div>
        </div>
        <div>
          <div class="header-container padding-top-50">
            <div class="empty-div">&nbsp;</div>
            <div class="header-content">補足説明</div>
          </div>
        </div>
        <div class="center-div" >
          <div style="text-align=left; !important /*notworking*/">
              1. プラン利用料は毎月1日～末日の単位で計算され、ご利用開始／終了した日付にかかわらず、その月1か月分の費用がかかります。
              <br>
              2. 表示価格は、特別な記載のない限り消費税は含まれておりません。
              <br>
              3. 内容は予告なく変更される場合がございます。
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PricingTable',
  components: {}
}
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

.center-div a:active {
  text-decoration: underline;
}

.width-100 {
  width: 100%;
}

.container {
  width: 100%;
  font-family: 游ゴシック体, "Yu Gothic", YuGothic, "ヒラギノ角ゴシック Pro",
    "Hiragino Kaku Gothic Pro", メイリオ, Meiryo, Osaka, "ＭＳ Ｐゴシック",
    "MS PGothic", sans-serif;
}

section {
  width: 100%;
  height: 100%;
}

.margin-top-60 {
  margin-top: 60px;
}

.cyan-background {
  background-color: rgb(230, 243, 243) !important;
}

.blue-background {
  background-color: #2ea7df !important;
}

.grey-background {
  background-color: grey !important;
}

.header-container,
.center-div {
  text-align: center;
  margin: auto;
  width: 90%;
}

.navi-title {
  font-weight: 800;
  padding: 20px 0px 0px;
}

.padding-top-50 {
  padding-top: 50px;
}

.header-container .empty-div {
  height: 8px;
  background-color: #2ea7df;
  width: 185px;
  font-size: 5px;
  margin-left: auto;
  margin-right: auto;
}

.header-container .header-content {
  display: block;
  width: 100%;
}

/*テーブルのボックス*/
.pricing-table-box {
  padding: 0px;
  margin: 0 auto;
  width: 100%;
}

.short-term .pricing-table-box {
  border-spacing: 0px;
  border: 1px solid rgb(98, 187, 223);
  border-collapse: collapse;
}

.long-term .pricing-table-box td {
  padding: 0px;
  border-left: 1px solid transparent;
}

.short-term .pricing-table-box td {
  padding: 0px;
  border: 1px solid rgb(98, 187, 223);
}

.pricing-table-box .pricing-table-box-list td {
  padding: 10px 8px;
  font-weight: 500;
  text-align: center;
  font-size: 14px;
}

.long-term .pricing-table-box .pricing-table-box-list td {
  background: #f9f9f9;
}

.pricing-table-box .pricing-table-box-list .glyphicon {
  color: rgb(9, 198, 255);
  font-weight: 900;
  font-size: 30px;
  text-shadow: 1.25px -1.5px blue;
}

.pricing-table-box .pricing-table-box-list td:first-child {
  font-weight: 400;
  text-align: left;
  border-left: 0px;
  font-size: 14px;
  color: #060606;
}

.long-term .pricing-table-box .pricing-table-box-list:nth-child(2n) td {
  background: rgb(217, 239, 248);
}

.long-term .pricing-table-box .pricing-table-box-text p {
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #666;
  margin-top: 10px;
}

/*テーブルのヘーダ*/
.pricing-table-box .pricing-table-box-item .pricing-table-box-item-price {
  padding: 20px 10px;
  text-align: center;
  color: black;
  width: inherit;
}

.long-term .pricing-table-box-item .pricing-table-box-item-price {
  background: #f9f9f9;
  vertical-align: top;
  min-height: 267px;
}

.short-term .pricing-table-box-item .pricing-table-box-item-price {
  background: rgb(195, 217, 226) !important;
  min-height: 100px;
}

.pricing-table-box
  .pricing-table-box-item
  .pricing-table-box-item-price
  .package-desc {
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
  margin-bottom: 0px;
}

.long-term .package-name {
  font-size: 35px;
  font-weight: 600;
  line-height: 5px;
  margin-bottom: 0px;
}

.short-term .package-name {
  font-weight: 600;
  font-size: 25px;
}

.pricing-table-box
  .pricing-table-box-item
  .pricing-table-box-item-price
  .package-price {
  font-size: 41px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #009ad7 !important;
}

.pricing-table-box
  .pricing-table-box-item
  .pricing-table-box-item-price
  p
  span {
  font-size: 12px;
  font-weight: 300;
  color: #009ad7;
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 45px;
  font-weight: 700;
}

.flex-navi-container {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.flex-navi-container > div {
  margin: 0px 18px;
}

.navi-box {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
}

.formula-box {
  text-align: center;
  height: 192px;
  width: 260px;
  font-weight: 400;
}

.formula-box .formula-box-head {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: rgb(8, 38, 122);
  font-size: 25px;
  height: 66px;
}

.formula-box .formula-box-body {
  display: block;
  text-align: left;
  padding: 15px 7.5px 0px 7.5px;
  height: 126px;
  font-size: 16px;
  background-color: white;
}
.formula-box .formula-box-end {
  justify-content: center;
  background-color: rgb(8, 38, 122);
  color: white;
  font-size: 25px;
  text-align: center;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*option*/
.option-div {
  font-size: 35px;
  color: white;
  font-weight: 600;
  text-align: center;
}

.option-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: flex-start;
}

.option-column {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  width: 100%;
}

.option-first-column {
  background-color: white;
  border-right: 2px dotted grey;
  border-bottom: 1px solid grey;
  padding: 10px 8px;
  text-align: left;
}
.option-second-column {
  background-color: white;
  border-bottom: 1px solid grey;
  padding: 10px 8px;
  text-align: center;
}

@media only screen and (max-width: 506px) {
  section {
    width: auto;
  }
  #option {
    width: 100%;
  }
  p {
    font-size: 15px;
  }
  .pricing-table-box {
    padding: 0px;
    margin-left: 0px;
    box-sizing: border-box;
  }
  /*448*/
  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-desc {
    font-size: 1px;
    padding: 0px;
  }

  .long-term .package-name {
    font-size: 5px;
    padding: 3px 0px;
  }

  .short-term .package-name {
    font-size: 13px;
  }

  .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-price {
    font-size: 10px;
    padding: 0px;
  }

  .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    p
    span {
    font-size: 1px;
  }
  .flex-container {
    flex-direction: column;
    font-size: 45px;
    font-weight: 700;
  }

  .formula-box {
    width: 100%;
    height: auto;
  }

  .flex-navi-container {
    flex-direction: column;
    margin: 0 1px;
  }

  .pricing-table-box .pricing-table-box-list .glyphicon {
    font-size: 15px;
    padding: 0px;
  }

  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price {
    padding: 0px;
    min-height: 130px;
  }
  /*this area needs work*/
  .short-term .pricing-table-box-item-price {
    min-height: 35px;
  }

  .short-term .pricing-table-box .pricing-table-box-item {
    min-height: 35px;
  }

  .option-column {
    font-size: 13px;
  }
}

@media only screen and (min-width: 507px) and (max-width: 767px) {
  .pricing-table-box {
    width: 90%;
  }

  #option {
    width: 90%;
  }

  /*448*/
  .pricing-table-box .pricing-table-box-item .pricing-table-box-item-price p {
    font-size: 10px;
  }
  .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-desc {
    font-size: 3px;
  }

  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price.package-name {
    font-size: 10px;
  }

  .short-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price.package-name {
    font-size: 15px;
  }

  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-price {
    font-size: 15px;
  }

  .flex-container {
    flex-direction: column;
    font-size: 45px;
    font-weight: 700;
  }

  .formula-box {
    width: 100%;
    height: auto;
  }

  .formula-box .formula-box-head {
    font-size: 25px;
  }
  .formula-box .formula-box-end {
    font-size: 25px;
  }
  .formula-box .formula-box-body {
    font-size: 20px;
    height: auto;
    padding-bottom: 10px;
  }
  .option-column {
    font-size: 15px;
  }

  .pricing-table-box .pricing-table-box-list .glyphicon {
    font-size: 15px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 849px) {
  .pricing-table-box {
    width: 90%;
  }

  .pricing-table-box .pricing-table-box-item .pricing-table-box-item-price p {
    font-size: 15px;
  }

  .long-term .package-desc {
    font-size: 10px;
  }

  .long-term .package-name {
    font-size: 25px;
  }

  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-price {
    font-size: 15px;
  }

  .formula-box {
    width: 100%;
    height: auto;
  }

  .flex-container {
    flex-direction: column;
    font-size: 45px;
    font-weight: 700;
  }

  .formula-box .formula-box-head {
    font-size: 30px;
  }
  .formula-box .formula-box-end {
    font-size: 30px;
  }
  .formula-box .formula-box-body {
    font-size: 20px;
    height: auto;
    padding-bottom: 10px;
  }
}

@media only screen and (min-width: 850px) and (max-width: 899px) {
  .formula-box .formula-box-head {
    font-size: 20px;
  }
  .formula-box .formula-box-end {
    font-size: 20px;
  }
  .pricing-table-box {
    width: 95%;
  }

  .long-term .package-desc {
    font-size: 10px;
  }

  .long-term .package-name {
    font-size: 25px;
  }

  .long-term
    .pricing-table-box
    .pricing-table-box-item
    .pricing-table-box-item-price
    .package-price {
    font-size: 35px;
  }

  #option {
    width: 95%;
  }

  .long-term .pricing-table-box-item .pricing-table-box-item-price {
    min-height: 250px;
  }
}

@media only screen and (min-width: 900px) {
  .pricing-table-box {
    width: 95%;
  }

  #option {
    width: 95%;
  }
}

@media only screen and (min-width: 1024px) {
  .pricing-table-box {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PricingTable.vue